import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, catchError, switchMap, exhaustMap } from 'rxjs/operators'
import { of } from 'rxjs'
import { ToastrService } from 'ngx-toastr'
// import { Store } from '@ngrx/store'
import {
  createClockInClockOut,
  createClockInClockOutFailure,
  createClockInClockOutSuccess,
  createEvent,
  createEventSuccess,
  createEventFailure,
  getLatestClockIn,
  getLatestClockInFailure,
  getLatestClockInSuccess,
  loadAttendances,
  loadAttendancesFailure,
  loadAttendancesSuccess,
  loadEmployeeAttendance,
  loadEmployeeAttendanceFailure,
  loadEmployeeAttendanceSuccess,
  updateClockIn,
  updateClockInFailure,
  updateClockInSuccess
} from './clockIn-clockOut.actions'
import { ClockInClockOutService } from '../../services/clockIn-clockOut.service'
// import { response } from 'express'
import { WorkStatus } from '../../components/attendance/calander/calander.component'

export const loadAttendances$ = createEffect(
  (actions$ = inject(Actions), clockInClockOutService = inject(ClockInClockOutService)) =>
    actions$.pipe(
      ofType(loadAttendances),
      switchMap(action =>
        clockInClockOutService.getAttendances(action).pipe(
          map(res =>
            loadAttendancesSuccess({
              totalPresentToday: res.totalPresentToday,
              lateLoginsToday: res.lateLoginsToday,
              todayPlannedLeaves: res.todayPlannedLeaves,
              todayUnplannedLeaves: res.todayUnplannedLeaves,
              absentToday: res.absentToday,
              employeeCount: res.employeeCount,
              totalCount: res.totalCount,
              clockinclockouts: res.clockInOuts
            })
          ),
          catchError(error => of(loadAttendancesFailure({ error: error.message })))
        )
      )
    ),
  { functional: true }
)

export const createClockIn$ = createEffect(
  (
    actions$ = inject(Actions),
    clockInClockOutService = inject(ClockInClockOutService),
    toastr = inject(ToastrService) // Inject the ToastrService
    // store = inject(Store)
  ) =>
    actions$.pipe(
      ofType(createClockInClockOut),
      exhaustMap(({ clockIn }) =>
        clockInClockOutService.createClockInOut({ clockIn }).pipe(
          map(response => {
            // Show a success message using Toastr
            toastr.success('Clock In successfully!', 'Success')
            // Dispatch the success action
            const successAction = createClockInClockOutSuccess({
              clockInClockOut: response

              // latestPunchIn: response
            })

            //   store.dispatch(loadDesignations({ params: null, page: 1, limit: 10 }))

            return successAction
          }),
          catchError(error => {
            // Optionally, show an error message
            toastr.error(error.error.message, 'Error')
            return of(createClockInClockOutFailure({ error }))
          })
        )
      )
    ),
  { functional: true, dispatch: true }
)

export const getLatestClockIn$ = createEffect(
  (actions$ = inject(Actions), clockInClockOutService = inject(ClockInClockOutService)) =>
    actions$.pipe(
      ofType(getLatestClockIn),
      switchMap(({ id }) =>
        clockInClockOutService.getEmployeeLatestClockInOut(id).pipe(
          map(res => {
            const isPunchedIn =
              res.clockInOut.workStatus === WorkStatus.CLOCKIN && res.clockInOut.clockOut === null
            // console.log('is punched in', res.clockInOut?.workStatus === 'ClockIn')
            return getLatestClockInSuccess({
              clockInClockOuts: res.clockInClockOut,
              isPunchedIn: isPunchedIn,
              latestPunchIn: res.clockInOut
            })
          }),
          catchError(error => of(getLatestClockInFailure({ error: error.message })))
        )
      )
    ),
  { functional: true }
)

export const updateClockIn$ = createEffect(
  (
    actions$ = inject(Actions),
    clockInClockOutService = inject(ClockInClockOutService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(updateClockIn),
      exhaustMap(({ id }) =>
        clockInClockOutService.updateClockIn(id).pipe(
          map(updated => {
            // console.log('clock out update', updated)
            if (updated?.clockIn) {
              toastr.success('Clock Out successfully!', 'Success')
              return updateClockInSuccess({ clockInClockOut: updated })
            } else {
              // toastr.error("Can't clock out before one minute.", 'Error')
              return updateClockInFailure({ error: 'Empty response data' })
            }
          }),
          catchError(error => {
            // toastr.error('There was an error updating the ClockIn.', 'Error')
            const errorMessage = error.message || 'There was an error during clockout update.'
            // toastr.error(error.error.message, 'Error')
            toastr.error(errorMessage, 'Error') // Show error message

            return of(updateClockInFailure({ error: errorMessage }))
          })
        )
      )
    ),
  { functional: true, dispatch: true }
)

export const loadEmployeeAttendance$ = createEffect(
  (actions$ = inject(Actions), clockInClockOutService = inject(ClockInClockOutService)) =>
    actions$.pipe(
      ofType(loadEmployeeAttendance),
      switchMap(({ id, params }) =>
        clockInClockOutService.getEmployeeAttendance(id, params).pipe(
          map(res =>
            loadEmployeeAttendanceSuccess({
              totalCount: res.totalCount,
              attendances: res.clockInOuts,
              totalWorkHoursThisWeek: res.totalWorkHoursThisWeek,
              totalWorkHoursThisMonth: res.totalWorkHoursThisMonth,
              totalWorkHoursToday: res.totalWorkHoursToday,
              totalProductiveWorkHoursToday: res.totalProductiveWorkHoursToday,
              totalBreakHoursToday: res.totalBreakHoursToday,
              todaysClockinoutRecords: res.todaysClockinoutRecords,
              expectedWorkHoursToday: res.expectedWorkHoursToday,
              expectedWorkHoursThisWeek: res.expectedWorkHoursThisWeek,
              expectedWorkHoursThisMonth: res.expectedWorkHoursThisMonth,
              totalOvertimeToday: res.totalOvertimeToday,
              totalOvertimeThisMonth: res.totalOvertimeThisMonth
            })
          ),
          catchError(error => of(loadEmployeeAttendanceFailure({ error: error.message })))
        )
      )
    ),
  { functional: true }
)

// export const getLatestClockInAfterPunchIn$ = createEffect((actions$ = inject(Actions)) =>
//   actions$.pipe(
//     ofType(createClockInClockOutSuccess), // Listen for successful clock-in creation
//     mergeMap(({ clockInClockOut }) => {
//       // Dispatch getLatestClockIn with the id of the newly created clock-in
//       return of(getLatestClockIn({ id: clockInClockOut.id }))
//     })
//   )
// )

export const createEvent$ = createEffect(
  (
    actions$ = inject(Actions),
    clockInClockOutService = inject(ClockInClockOutService),
    toastr = inject(ToastrService) // Inject the ToastrService
    // store = inject(Store)
  ) =>
    actions$.pipe(
      ofType(createEvent),
      exhaustMap(({ clockIn, workStatus, lateLogin, userId, timeZone }) =>
        clockInClockOutService
          .createEvent({ clockIn, workStatus, lateLogin, userId, timeZone })
          .pipe(
            map(response => {
              // Show a success message using Toastr
              toastr.success('Event created successfully!', 'Success')
              // Dispatch the success action
              const successAction = createEventSuccess({
                clockInClockOut: response

                // latestPunchIn: response
              })

              //   store.dispatch(loadDesignations({ params: null, page: 1, limit: 10 }))

              return successAction
            }),
            catchError(error => {
              // Optionally, show an error message
              toastr.error(error.error.message, 'Error')
              return of(createEventFailure({ error }))
            })
          )
      )
    ),
  { functional: true, dispatch: true }
)

export const clockInClockOutEffects = {
  loadAttendances$,
  createClockIn$,
  getLatestClockIn$,
  updateClockIn$,
  loadEmployeeAttendance$,
  createEvent$
}
